import React from 'react';
import { Input } from '@oscar/theme';
import moment from 'moment';
import { filter } from 'lodash';

const InputText = (props: { value?: any; mappingData?: any }) => {
  const { value, mappingData } = props;

  const transferData = (data: any, oldValue: any) => {
    const newValue = filter(data, (item: any) => item.id === oldValue);
    return newValue[0]?.label;
  };

  return <Input {...props} value={transferData(mappingData, value)} disabled />;
};

export default InputText;
